import { useMsal } from '@azure/msal-react';
import { useCallback } from 'react';
import { acquireToken } from './acquireToken';

/**
 * Returns a getter that silently acquires an API access token, falling back to
 * an interactive redirect when the refresh token can't satisfy the request.
 * Feed this to the generated api-client so token handling lives in exactly one place.
 *
 * The policy itself is in `acquireToken`, which knows nothing about React — that is what lets
 * the two rules it has to keep (fall back on *any* silent failure; never throw once a redirect
 * is under way) be tested without a browser and a 24-hour-old refresh token.
 */
export function useAccessToken(scope: string): () => Promise<string> {
  const { instance, accounts } = useMsal();

  return useCallback(async () => {
    const account = accounts[0];
    if (!account) throw new Error('No signed-in account.');

    return acquireToken(instance, account, scope);
  }, [instance, accounts, scope]);
}
